import {Form} from "./Form";

function page(param) {
    param = typeof param === 'string' ? {'name': param } : param;
    const name = param.name;
    const defParam = APP.pagesParam[name];

    for (let key in defParam) {
        if(param.hasOwnProperty(key)) continue;
        else param[key] = defParam[key];
    }

    console.log('page param', param);

    class Page{
        constructor(){
            this.show();
        }

        handleEvent(event){
            event.preventDefault();
            this.show();
        }

        _getContent(){
            return new Promise((resolve, reject) => {
                var xhr = new XMLHttpRequest();
                xhr.open("POST", param.ajax, true);
                xhr.setRequestHeader("X-Request-Ajax","1");
                xhr.setRequestHeader("X-Request-Referer", window.location.toString());
                xhr.onload = function(){
                    if(xhr.status != 200) reject(xhr);
                    else resolve(xhr.responseText);
                };
                xhr.send('');
            });
        }

        show(){
            var cls = param.cls ? param.cls  : 'popup-middle';
            var self = this;

            this._getContent()
                .then(
                    (content) => {
                        uPopup.closeAll();
                        this.popup = uPopup({
                            addClass:cls,
                            name: name,
                            content:content,
                            onopen:(wrapper) => {
                                this.moduleAll = APP.modules.run(wrapper, 'data-PopupForm-modules');
                            },
                            oncloseBefore: () => {
                                APP.modules.destroy(this.moduleAll);
                                return true;
                            }
                        });
                    }, (xhr) =>{
                        console.log('pageModule reject, xhr status:', xhr.status);
                    }
                )
        }

        addBtn(btn){
            btn.addEventListener('click', this);
            this.btnAll.push(btn);
        }
    }
    let init = function(){
        return new Page();``
    };

    //
    init();
}




export {page};



